import { z } from 'zod';

export const OneWayFeeSchema = z.object({
  name: z.string().optional(),
  departureCity: z.string().optional(),
  arrivalCity: z.string().optional(),
  description: z.string().optional(),
  amount: z.coerce.number().int().min(0).optional(),
});

export const ExtendedOneWayFeesSchema = z.object({
  oneWayFees: z.array(OneWayFeeSchema),
});

export type ExtendedOneWayFeesFormData = z.infer<
  typeof ExtendedOneWayFeesSchema
>;
